export default "__VITE_ASSET__BkBETg4o__"